
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class JournalDetailDialog extends _Ext.EditorDialogBase<JournalDetailRow> {
        protected getFormKey() { return JournalDetailForm.formKey; }
        protected getLocalTextPrefix() { return JournalDetailRow.localTextPrefix; }
        protected getDeletePermission() { return JournalDetailRow.deletePermission; }
        protected getInsertPermission() { return JournalDetailRow.insertPermission; }
        protected getUpdatePermission() { return JournalDetailRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        protected form = new JournalDetailForm(this.idPrefix);
        public exchangerate;
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.ExchangeRateId);
            
            this.form.LedgerId.changeSelect2(e => {
                if (this.form.LedgerId.value == "1001") {
                    this.form.Mode.value = "Cash";
                    Serenity.EditorUtils.setReadOnly(this.form.Mode, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
                    Serenity.EditorUtils.setRequired(this.form.ChequeDate, false);
                    Serenity.EditorUtils.setRequired(this.form.ChequeNo, false);
                }
                else {
                    this.form.Mode.value = "Cheque";
                    Serenity.EditorUtils.setReadOnly(this.form.Mode, true);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, false);
                    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, false);
                    Serenity.EditorUtils.setRequired(this.form.ChequeDate, true);
                    Serenity.EditorUtils.setRequired(this.form.ChequeNo, true);
                }
            });
            this.form.Amount.changeSelect2(e => {
                var amount = (this.parentEditor.parentDialog as JournalDialog).form.TotalAmount.value;
                if (parseFloat(this.form.Amount.value.toString()) > amount) {

                }
            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            var currencyid = (this.parentEditor.parentDialog as JournalDialog).form.CurrencyId.value;
            if (currencyid == null) {
                Q.alert('Please Select Currency');
                Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
                this.dialogClose();
                return;
            } else {
                this.form.ExchangeRateId.value = Q.Authorization.userDefinition.exchangerate;
                Serenity.EditorUtils.setReadonly(this.form.ExchangeRateId.element, true);                
            }
            var ledgerid = (this.parentEditor.parentDialog as JournalDialog).form.LedgerId.value;
            if ( ledgerid == null) {
                Q.alert('Please Select Party');
                this.dialogClose();
                return;
            }
            //if (JournalDetailDialog.lock) {
            //    this.element.find('.tool-buttons').attr("style", "display:none;");
            //    this.element.find('.s-DialogToolbar').attr("style", "display:none;");
            //    this.element.find('.s-Toolbar').attr("style", "display:none;");
            //    this.element.find('.clearfix').attr("style", "display:none;");
            //    Serenity.EditorUtils.setReadOnly(this.form.Mode, true);
            //    Serenity.EditorUtils.setReadOnly(this.form.ChequeDate, true);
            //    Serenity.EditorUtils.setReadOnly(this.form.ChequeNo, true);
            //    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
            //    Serenity.EditorUtils.setReadOnly(this.form.LedgerId, true);
            //}
        }
        
        
    }
}